import PyramidHeader from './PyramidHeader';

export default PyramidHeader;
